import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined'
import { Box, Button, Stack, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import { useIntl } from 'react-intl'

export interface UploadDropzoneProps {
  onFiles: (files: File[]) => void
  disabled?: boolean
}

export default function UploadDropzone({
  onFiles,
  disabled = false,
}: UploadDropzoneProps) {
  const { formatMessage } = useIntl()
  const input = useRef<HTMLInputElement>(null)
  const [over, setOver] = useState(false)

  const take = (list: FileList | null) => {
    if (list && list.length) {
      onFiles(Array.from(list))
    }
  }

  return (
    <Box
      onDragOver={(e) => {
        e.preventDefault()
        setOver(true)
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault()
        setOver(false)
        if (!disabled) {
          take(e.dataTransfer?.files ?? null)
        }
      }}
      sx={{
        p: 3,
        border: '2px dashed',
        borderColor: over ? 'primary.main' : 'divider',
        borderRadius: 1,
        bgcolor: over ? 'action.hover' : 'transparent',
        textAlign: 'center',
      }}
    >
      <Stack spacing={1} alignItems="center">
        <UploadFileOutlinedIcon color="action" aria-hidden={true} />
        <Typography variant="body2">
          {formatMessage({ id: 'avatarStudio.upload.dropHere' })}
        </Typography>
        <Button
          size="small"
          disabled={disabled}
          onClick={() => input.current?.click()}
        >
          {formatMessage({ id: 'avatarStudio.upload.browse' })}
        </Button>
        <input
          ref={input}
          type="file"
          multiple={true}
          accept="image/png"
          hidden={true}
          aria-label={formatMessage({ id: 'avatarStudio.upload.browse' })}
          onChange={(e) => {
            take(e.target.files)
            e.target.value = ''
          }}
        />
        <Typography variant="caption" color="text.secondary">
          {formatMessage({ id: 'avatarStudio.upload.oneOptionOnly' })}
        </Typography>
      </Stack>
    </Box>
  )
}
